import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { Paper, List, Divider } from '@mui/material';

import {
    visibleZonesListSelector,
    pinnedZonesListSelector
} from '../../features/places/placesSlice';
import ZoneListItem from './ZoneListItem';


const ZonesListView = ({ setListViewCallback }) => {
    const visibleZonesList = useSelector(visibleZonesListSelector);
    const pinnedZones = useSelector(pinnedZonesListSelector);

    const buildZonesList = () => {
        return visibleZonesList.map((zoneId, index) => {
            return (<Fragment key={zoneId}>
                <ZoneListItem
                    zoneId={zoneId}
                    pinned={pinnedZones.indexOf(zoneId) !== -1}
                    setListViewCallback={setListViewCallback}
                />
                {
                    index < visibleZonesList.length - 1 && <Divider component="li" />
                }
            </Fragment>)
        })
    }
    if (visibleZonesList && visibleZonesList.length > 0) {
        return (
            <Paper elevation={3}>
                <List dense>
                    {buildZonesList()}
                </List>
            </Paper>
        );
    } else {
        return null;
    }

}

export default ZonesListView;